import { render, staticRenderFns } from "./StaticHowItWorks.vue?vue&type=template&id=7b9ef3cc&"
import script from "./StaticHowItWorks.vue?vue&type=script&lang=js&"
export * from "./StaticHowItWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports